export default {
  // Common
  'common.codeExample': 'コード例',
  'common.tryItYourself': '自分で試してみる',
  'common.output': '出力',
  'common.explanation': '説明',
  'common.bestPractices': 'ベストプラクティス',
  'common.commonMistakes': 'よくある間違い',
  'common.relatedFunctions': '関連関数',

  // MySQL Timestamp Page
  'mysql.mainTitle': 'MySQLタイムスタンプ完全ガイド',
  'mysql.mainTitleSEO': 'MySQLタイムスタンプチュートリアル - UNIX_TIMESTAMP & FROM_UNIXTIMEガイド',
  'mysql.subtitle': 'MySQLタイムスタンプ関数、データ型、タイムゾーン処理をマスター',

  'mysql.intro': 'MySQLはUnixタイムスタンプを扱うための強力な関数を提供します。このガイドは、基本的なタイムスタンプ関数から高度なタイムゾーン処理まですべてをカバーしています。',

  // UNIX_TIMESTAMP() Section
  'mysql.unixTimestampTitle': 'UNIX_TIMESTAMP()関数',
  'mysql.unixTimestampDesc': '日付/日時をUnixタイムスタンプ（1970-01-01 00:00:00 UTCからの秒数）に変換',
  'mysql.getCurrentTimestamp': '現在のUnixタイムスタンプを取得',
  'mysql.convertDateToTimestamp': '日付をタイムスタンプに変換',
  'mysql.example1': '現在のUnixタイムスタンプを秒単位で返す',
  'mysql.example2': '特定の日時をタイムスタンプに変換',

  // FROM_UNIXTIME() Section
  'mysql.fromUnixtimeTitle': 'FROM_UNIXTIME()関数',
  'mysql.fromUnixtimeDesc': 'UnixタイムスタンプをMySQLの日時形式に変換',
  'mysql.convertTimestampToDate': 'タイムスタンプを日時に変換',
  'mysql.formatTimestamp': 'カスタムパターンでタイムスタンプをフォーマット',

  // TIMESTAMP vs DATETIME
  'mysql.typesTitle': 'TIMESTAMPとDATETIMEデータ型',
  'mysql.timestampType': 'TIMESTAMP型',
  'mysql.timestampFeature1': '範囲：1970-01-01から2038-01-19',
  'mysql.timestampFeature2': 'UTCで保存され、ローカルタイムゾーンに変換',
  'mysql.timestampFeature3': 'INSERT/UPDATE時に自動更新',
  'mysql.timestampFeature4': '4バイトのストレージを使用',

  'mysql.datetimeType': 'DATETIME型',
  'mysql.datetimeFeature1': '範囲：1000-01-01から9999-12-31',
  'mysql.datetimeFeature2': 'そのまま保存、タイムゾーン変換なし',
  'mysql.datetimeFeature3': '手動更新',
  'mysql.datetimeFeature4': '8バイトのストレージを使用',

  // Practical Examples
  'mysql.practicalTitle': '実用的なSQL例',
  'mysql.example.insert': '現在のタイムスタンプを挿入',
  'mysql.example.query': 'タイムスタンプ範囲でレコードをクエリ',
  'mysql.example.update': 'タイムスタンプ列を更新',
  'mysql.example.aggregation': 'タイムスタンプ集約',

  // Timezone Handling
  'mysql.timezoneTitle': 'MySQLでのタイムゾーン処理',
  'mysql.timezoneDesc': 'MySQLはTIMESTAMP値をUTCで保存し、接続タイムゾーンに変換します',
  'mysql.setTimezone': 'セッションタイムゾーンを設定',
  'mysql.convertTimezone': 'タイムゾーン間で変換',

  // Common Use Cases
  'mysql.useCasesTitle': '一般的な使用例',
  'mysql.useCase1.title': 'レコード作成時刻を追跡',
  'mysql.useCase1.desc': 'DEFAULT CURRENT_TIMESTAMPを使用して作成時刻を自動設定',

  'mysql.useCase2.title': '最終更新時刻を追跡',
  'mysql.useCase2.desc': 'ON UPDATE CURRENT_TIMESTAMPを使用して変更時刻を自動更新',

  'mysql.useCase3.title': '日付範囲でフィルタリング',
  'mysql.useCase3.desc': 'UNIX_TIMESTAMP()を使用してタイムスタンプ範囲でレコードをフィルタリング',

  'mysql.useCase4.title': '期間ごとにグループ化',
  'mysql.useCase4.desc': 'FROM_UNIXTIME()とDATE_FORMAT()を使用してレコードをグループ化',

  // Performance Tips
  'mysql.performanceTitle': 'パフォーマンス最適化のヒント',
  'mysql.perf1': 'WHERE句で使用されるタイムスタンプ列にインデックスを作成',
  'mysql.perf2': 'タイムゾーン変換が必要な列にはTIMESTAMPを使用',
  'mysql.perf3': 'TIMESTAMP範囲外の歴史的な日付にはDATETIMEを使用',
  'mysql.perf4': 'WHERE句で関数を使用しないようにする - インデックス付き列を使用',

  // FAQ
  'mysql.faq.q1': 'MySQLの2038年問題とは？',
  'mysql.faq.a1': 'TIMESTAMPは符号付き32ビット整数を使用し、2038年1月19日にオーバーフローします。2038年以降の日付にはDATETIMEを使用してください。',

  'mysql.faq.q2': 'MySQLでミリ秒を保存する方法は？',
  'mysql.faq.a2': 'BIGINTを使用してミリ秒単位のUnixタイムスタンプを保存するか、DATETIME(3)でミリ秒精度の日時を使用します。',

  'mysql.faq.q3': 'TIMESTAMPとDATETIMEのどちらを使用すべきですか？',
  'mysql.faq.a3': 'タイムゾーン認識が必要な最近の日付にはTIMESTAMPを使用します。タイムゾーン変換が不要な歴史的な日付にはDATETIMEを使用します。',

  'mysql.faq.q4': 'MySQLでタイムゾーンを処理する方法は？',
  'mysql.faq.a4': 'TIMESTAMP型を使用してすべてのタイムスタンプをUTCで保存し、表示時にローカルタイムゾーンに変換します。',

  // Python Timestamp Page
  'python.mainTitle': 'Pythonタイムスタンプ完全ガイド',
  'python.mainTitleSEO': 'Pythonタイムスタンプチュートリアル - datetime、time、calendarモジュールガイド',
  'python.subtitle': 'datetime、time、calendarモジュールを使用したPythonタイムスタンプ処理をマスター',

  'python.intro': 'Pythonはタイムスタンプを扱うための複数のモジュールを提供します。この包括的なガイドは、time、datetime、calendar、タイムゾーン処理をカバーしています。',

  // Get Current Timestamp
  'python.getCurrentTitle': '現在のUnixタイムスタンプを取得',
  'python.getCurrentDesc': 'Pythonで現在のUnixタイムスタンプを取得する複数の方法',
  'python.method1': 'time.time()を使用 - floatを返す',
  'python.method2': 'datetime.now()を使用 - integerを返す',
  'python.method3': 'calendarモジュールを使用',

  // Convert Timestamp to Datetime
  'python.toDatetimeTitle': 'タイムスタンプを日時に変換',
  'python.toDatetimeDesc': 'UnixタイムスタンプをPythonのdatetimeオブジェクトに変換',
  'python.fromTimestamp': 'datetime.fromtimestamp()を使用',
  'python.formatDatetime': '日時文字列をフォーマット',
  'python.timezoneAware': 'タイムゾーン認識日時',

  // Convert Datetime to Timestamp
  'python.toTimestampTitle': '日時をタイムスタンプに変換',
  'python.toTimestampDesc': 'PythonのdatetimeオブジェクトをUnixタイムスタンプに変換',
  'python.usingTimestamp': '.timestamp()メソッドを使用',
  'python.usingMktime': 'time.mktime()を使用',

  // Timezone Handling
  'python.timezoneTitle': 'タイムゾーン処理',
  'python.timezoneDesc': 'pytzとzoneinfoを使用したタイムゾーン処理',
  'python.pytzExample': 'pytzライブラリを使用',
  'python.zoneinfoExample': 'zoneinfoを使用（Python 3.9+）',

  // Common Patterns
  'python.patternsTitle': '一般的なパターンと使用例',
  'python.pattern1.title': 'タイムスタンプ演算',
  'python.pattern1.desc': 'タイムスタンプに時間を加算または減算',

  'python.pattern2.title': 'タイムスタンプの比較',
  'python.pattern2.desc': '2つのタイムスタンプを比較して時間差を求める',

  'python.pattern3.title': 'タイムスタンプの丸め',
  'python.pattern3.desc': 'タイムスタンプを最も近い日/時間/分に丸める',

  'python.pattern4.title': '文字列をタイムスタンプに解析',
  'python.pattern4.desc': '日付文字列をタイムスタンプに変換',

  // JavaScript Timestamp Page
  'javascript.mainTitle': 'JavaScriptタイムスタンプ完全ガイド',
  'javascript.mainTitleSEO': 'JavaScriptタイムスタンプチュートリアル - Dateオブジェクト&メソッドガイド',
  'javascript.subtitle': 'JavaScriptのDateオブジェクト、タイムスタンプメソッド、タイムゾーン処理をマスター',

  'javascript.intro': 'JavaScriptはタイムスタンプを扱うためのDateオブジェクトを提供します。このガイドは、基本的なメソッドから高度なタイムゾーン処理まですべてをカバーしています。',

  // Get Current Timestamp
  'javascript.getCurrentTitle': '現在のUnixタイムスタンプを取得',
  'javascript.getCurrentDesc': 'JavaScriptで現在のタイムスタンプを取得する複数の方法',
  'javascript.dateNow': 'Date.now()を使用 - 最も効率的',
  'javascript.getTime': 'new Date().getTime()を使用',
  'javascript.valueOf': 'valueOf()メソッドを使用',
  'javascript.unaryPlus': '単項+演算子を使用',

  // Convert Timestamp to Date
  'javascript.toDateTitle': 'タイムスタンプを日付に変換',
  'javascript.toDateDesc': 'UnixタイムスタンプをJavaScriptのDateオブジェクトに変換',
  'javascript.newDate': 'タイムスタンプからDateを作成',
  'javascript.formatDate': '日付文字列をフォーマット',
  'javascript.toLocaleString': 'toLocaleString()を使用してフォーマット',

  // Convert Date to Timestamp
  'javascript.toTimestampTitle': '日付をタイムスタンプに変換',
  'javascript.toTimestampDesc': 'JavaScriptのDateをUnixタイムスタンプに変換',
  'javascript.parseDate': '日付文字列をタイムスタンプに解析',
  'javascript.dateComponents': 'コンポーネントからタイムスタンプを作成',

  // Date Libraries
  'javascript.librariesTitle': '人気の日付ライブラリ',
  'javascript.momentJs': 'Moment.js（レガシー）',
  'javascript.dayJs': 'Day.js（軽量）',
  'javascript.dateFns': 'date-fns（モダン）',
  'javascript.luxon': 'Luxon（タイムゾーン認識）',

  // Java & PHP - Similar structure
  'java.mainTitle': 'Javaタイムスタンプ完全ガイド',
  'java.mainTitleSEO': 'Javaタイムスタンプチュートリアル - Date、Calendar、Instantガイド',
  'java.subtitle': 'Date、Calendar、Instant、LocalDateTimeを使用したJavaタイムスタンプ処理をマスター',
  'java.intro': 'Javaはタイムスタンプを扱うための複数のAPIを提供します。このガイドは、レガシーのDate/Calendarクラスと最新のjava.time API（Java 8+）をカバーしています。',

  // Get Current Timestamp
  'java.getCurrentTitle': '現在のUnixタイムスタンプを取得',
  'java.getCurrentDesc': 'Javaで現在のタイムスタンプを取得する複数の方法',
  'java.method1': 'System.currentTimeMillis()を使用 - 最速',
  'java.method2': 'Instant.now()を使用 - モダン（Java 8+）',
  'java.method3': 'Dateクラスを使用 - レガシー',

  // Convert Timestamp to Date
  'java.toDateTitle': 'タイムスタンプを日付に変換',
  'java.toDateDesc': 'UnixタイムスタンプをJavaのDate/Instant/LocalDateTimeに変換',
  'java.fromTimestamp': 'Instant.ofEpochSecond()を使用',
  'java.toLocalDateTime': 'LocalDateTimeに変換',
  'java.formatDate': 'DateTimeFormatterでフォーマット',

  // Convert Date to Timestamp
  'java.toTimestampTitle': '日付をタイムスタンプに変換',
  'java.toTimestampDesc': 'JavaのDate/Instant/LocalDateTimeをUnixタイムスタンプに変換',
  'java.dateToTimestamp': 'Date.getTime()を使用',
  'java.instantToTimestamp': 'Instantメソッドを使用',

  // Timezone Handling
  'java.timezoneTitle': 'タイムゾーン処理',
  'java.timezoneDesc': 'ZoneIdとZonedDateTimeを使用したタイムゾーン処理',
  'java.zoneIdExample': 'ZoneIdを使用',
  'java.zonedDateTimeExample': 'ZonedDateTimeを使用',

  // Common Patterns
  'java.patternsTitle': '一般的なJavaタイムスタンプパターン',
  'java.pattern1.title': '日付演算',
  'java.pattern1.desc': 'DurationとPeriodを使用して時間を加算または減算',
  'java.pattern2.title': '日付文字列を解析',
  'java.pattern2.desc': 'DateTimeFormatterを使用して文字列をタイムスタンプに解析',
  'java.pattern3.title': 'タイムスタンプの比較',
  'java.pattern3.desc': '日付を比較し、差を計算',

  'php.mainTitle': 'PHPタイムスタンプ完全ガイド',
  'php.mainTitleSEO': 'PHPタイムスタンプチュートリアル - time()、strtotime()、DateTimeガイド',
  'php.subtitle': 'time()、date()、strtotime()、DateTimeクラスを使用したPHPタイムスタンプ処理をマスター',
  'php.intro': 'PHPはタイムスタンプを扱うための強力な関数を提供します。このガイドは、手続き型関数とオブジェクト指向DateTimeクラスの両方をカバーしています。',

  // Get Current Timestamp
  'php.getCurrentTitle': '現在のUnixタイムスタンプを取得',
  'php.getCurrentDesc': 'PHPで現在のタイムスタンプを取得する複数の方法',
  'php.method1': 'time()を使用 - 最も一般的',
  'php.method2': 'microtime()を使用 - マイクロ秒付き',
  'php.method3': 'DateTimeクラスを使用',

  // Convert Timestamp to Date
  'php.toDateTitle': 'タイムスタンプを日付に変換',
  'php.toDateDesc': 'Unixタイムスタンプをフォーマットされた日付文字列に変換',
  'php.dateFunction': 'date()関数を使用',
  'php.dateTimeClass': 'DateTimeクラスを使用',
  'php.formatDate': 'カスタム日付フォーマット',

  // Convert Date to Timestamp
  'php.toTimestampTitle': '日付をタイムスタンプに変換',
  'php.toTimestampDesc': '日付文字列をUnixタイムスタンプに変換',
  'php.strtotime': 'strtotime()を使用 - 英語テキストを解析',
  'php.dateTimeToTimestamp': 'DateTime::getTimestamp()を使用',

  // Timezone Handling
  'php.timezoneTitle': 'タイムゾーン処理',
  'php.timezoneDesc': 'DateTimeZoneを使用したタイムゾーン処理',
  'php.setTimezone': 'デフォルトタイムゾーンを設定',
  'php.dateTimeZone': 'DateTimeZoneクラスを使用',

  // Common Patterns
  'php.patternsTitle': '一般的なPHPタイムスタンプパターン',
  'php.pattern1.title': '日付演算',
  'php.pattern1.desc': 'strtotime()またはDateIntervalを使用して時間を加算または減算',
  'php.pattern2.title': '相対日付を解析',
  'php.pattern2.desc': '「next Monday」、「last week」などを解析',
  'php.pattern3.title': 'タイムスタンプの比較',
  'php.pattern3.desc': '日付を比較し、差を計算',

  // SQL Timestamp Page (Universal - MySQL, PostgreSQL, Oracle, SQL Server)
  'sql.mainTitle': 'SQLタイムスタンプ完全ガイド',
  'sql.mainTitleSEO': 'SQLタイムスタンプチュートリアル - MySQL、PostgreSQL、Oracle、SQL Server',
  'sql.subtitle': 'MySQL、PostgreSQL、Oracle、SQL Serverデータベース間のタイムスタンプ処理をマスター',

  'sql.intro': 'Unixタイムスタンプの操作は異なるSQLデータベース間で異なります。この包括的なガイドは、MySQL、PostgreSQL、Oracle、SQL Serverのタイムスタンプ関数をカバーし、Unixタイムスタンプとデータベースの日時形式間の変換を支援します。',

  // Database Selection
  'sql.selectDatabase': 'データベースを選択',

  // Comparison
  'sql.comparisonTitle': 'クイックリファレンス：データベース間のタイムスタンプ関数',

  // Common Use Cases
  'sql.commonUseCases': 'すべてのデータベースに共通する使用例',
  'sql.useCase1.title': '作成タイムスタンプを保存',
  'sql.useCase1.desc': 'デフォルトのタイムスタンプ値を使用してレコードが作成された時刻を自動追跡',
  'sql.useCase2.title': '最終更新時刻を追跡',
  'sql.useCase2.desc': 'レコードが変更されたときに変更タイムスタンプを自動更新',
  'sql.useCase3.title': '日付範囲でフィルタリング',
  'sql.useCase3.desc': '分析とレポート用の特定のタイムスタンプ範囲内のレコードをクエリ',
  'sql.useCase4.title': '期間ごとにグループ化',
  'sql.useCase4.desc': 'タイムスタンプ関数を使用して時間、日、月、年ごとにデータを集約',

  // Best Practices
  'sql.bestPractice1': 'タイムゾーンの混乱を避けるため、常にタイムスタンプをUTCで保存',
  'sql.bestPractice2': 'パフォーマンス向上のため、WHERE句で頻繁に使用されるタイムスタンプ列にインデックスを作成',
  'sql.bestPractice3': '可能な限りアプリケーションコードで変換する代わりにデータベースネイティブ関数を使用',
  'sql.bestPractice4': '32ビット整数タイムスタンプを使用する際は2038年問題に注意',
  'sql.bestPractice5': 'オーバーフロー問題を避けるため、ミリ秒タイムスタンプにはBIGINTを使用',
};
